// extracted by mini-css-extract-plugin
export default {"text":"Privacy_text__Q-U6y","container":"Privacy_container__avmcQ"};